import { useMutation } from "@tanstack/react-query";
import type { RoundName } from "../../domain/round/types";
import { trashConfirmedRound } from "./variantCompareApi";

export function ConfirmedRoundRecoveryAction({ tournamentId, round, disabled, onDone }: { tournamentId: string; round: RoundName; disabled?: boolean; onDone: (message: string) => void }) {
  const mutation = useMutation({
    mutationFn: () => trashConfirmedRound(tournamentId, round),
    onSuccess: (result) => onDone(`Potwierdzona ${round} trafiła do kosza (${result.trash.id.slice(0, 8)}). Można ją przywrócić w System → Recovery.`),
  });
  const error = mutation.error instanceof Error ? mutation.error.message : "";
  return <span className="confirmed-recovery-action">
    <button className="danger-button" type="button" disabled={disabled || mutation.isPending} onClick={() => {
      if (window.confirm(`Przenieść potwierdzoną ${round} do kosza? Workspace i historia wykonania zostaną zachowane i można je przywrócić w Recovery.`)) mutation.mutate();
    }}>{mutation.isPending ? "Przenoszę…" : "Do kosza"}</button>
    {error ? <small className="round-lifecycle-error">{error}</small> : null}
  </span>;
}
